const mediaItems = [
  {
    title: '热播剧集《星河之约》',
    tag: '电视剧',
    desc: '都市情感大戏，全网同步更新中。高清画质还原每一帧细腻情感，不缓冲畅享追剧乐趣。',
    img: 'https://readdy.ai/api/search-image?query=Modern%20urban%20romance%20drama%20scene%2C%20warm%20golden%20hour%20lighting%2C%20city%20skyline%20at%20sunset%2C%20cinematic%20composition%2C%20emotional%20storytelling%20atmosphere%2C%20soft%20bokeh%20background%2C%20film%20aesthetic%20with%20rich%20amber%20tones%2C%20dramatic%20lighting%2C%20professional%20cinematography%20style%2C%20intimate%20warm%20mood&width=800&height=500&seq=media-card-01&orientation=landscape',
  },
  {
    title: '院线大片《暗夜追击》',
    tag: '电影',
    desc: '年度动作悬疑巨制，4K超清画质呈现。紧张刺激的剧情搭配流畅播放体验，免费看大片。',
    img: 'https://readdy.ai/api/search-image?query=Action%20thriller%20movie%20scene%2C%20intense%20dramatic%20lighting%20with%20deep%20shadows%2C%20urban%20night%20chase%20atmosphere%2C%20cinematic%20wide%20shot%20composition%2C%20moody%20dark%20tones%20with%20warm%20highlights%2C%20film%20noir%20aesthetic%2C%20professional%20movie%20photography%2C%20suspenseful%20energy%2C%20high%20contrast%20visuals&width=800&height=500&seq=media-card-02&orientation=landscape',
  },
  {
    title: '爆笑综艺《欢乐星期天》',
    tag: '综艺',
    desc: '全网最火综艺节目高清完整版，笑点密集不卡顿。轻松追综艺，快乐每一天。',
    img: 'https://readdy.ai/api/search-image?query=Vibrant%20variety%20show%20stage%20scene%2C%20colorful%20dynamic%20stage%20lighting%2C%20warm%20spotlight%20effects%2C%20energetic%20entertainment%20atmosphere%2C%20modern%20TV%20production%20design%2C%20cheerful%20bright%20composition%2C%20lively%20celebration%20mood%2C%20professional%20broadcast%20aesthetic%2C%20rich%20warm%20tones%2C%20festive%20studio%20setting&width=800&height=500&seq=media-card-03&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading text-center mb-4">精彩片段</h2>
        <p className="text-sm text-foreground-500 text-center mb-10 max-w-lg mx-auto">精选热门影视内容预览，感受高清不缓冲的极致观影体验</p>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {mediaItems.map((item, i) => (
            <div key={i} className="group rounded-2xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer">
              <div className="relative aspect-video overflow-hidden bg-background-200">
                <img src={item.img} alt={item.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                <div className="absolute top-3 left-3">
                  <span className="px-3 py-1 rounded-full bg-primary-500 text-background-50 text-xs font-medium whitespace-nowrap">{item.tag}</span>
                </div>
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-14 h-14 flex items-center justify-center rounded-full bg-background-50/90 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300">
                    <i className="ri-play-fill text-2xl ml-0.5"></i>
                  </div>
                </div>
              </div>
              <div className="p-5">
                <h3 className="text-base font-bold text-foreground-900 mb-2">{item.title}</h3>
                <p className="text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}